import { render, staticRenderFns } from "./commissionconfig.vue?vue&type=template&id=95867078&"
import script from "./commissionconfig.vue?vue&type=script&lang=js&"
export * from "./commissionconfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports